// extracted by mini-css-extract-plugin
module.exports = {"row":"row--vOrIj"};